import { useContext } from "react";
import { AuthContext } from "./AuthContext";

/**
 * Hook for accessing authentication context
 * @returns {Object} Authentication state and methods
 * @returns {boolean} isAuthenticated - Whether user is authenticated
 * @returns {string} token - Auth token if present
 * @returns {Function} setToken - Function to set auth token
 * @returns {Function} unsetToken - Function to remove auth token
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  const { AuthToken, setToken, unsetToken } = context;

  return {
    isAuthenticated: Boolean(AuthToken),
    token: AuthToken,
    setToken,
    unsetToken,
  };
}
